import { render, staticRenderFns } from "./FacultiesView.vue?vue&type=template&id=75a9a1cb"
import script from "./FacultiesView.vue?vue&type=script&lang=js"
export * from "./FacultiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports